<template>
  <v-locale-provider :rtl="false">
    <AppSection>
      <AppContainer>
        <AppRow>
          <v-breadcrumbs :items="[{ title: 'Admin Panel', disabled: false, href: '/admin' }]" />
          <div v-if="loggedIn" class="text-end">
            <AppBtn @click="logout">Log out</AppBtn>
          </div>
        </AppRow>
        <h1>{{ title }}</h1>
        <slot />
      </AppContainer>
    </AppSection>
  </v-locale-provider>
</template>

<script setup lang="ts">
defineProps<{
  title: string;
}>();

const { onAuthChange, logout, loggedIn } = useAuth();

onAuthChange(state => {
  if (state == 'logged_out') {
    navigateTo('/admin/login');
  }
});
</script>